import React, {useEffect, useRef, useState} from 'react';
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {UsePermissions} from "../../../hooks/usePermissions";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {error} from "../../../shared/utils/utils";
import PropTypes from "prop-types";
import {Toast} from "primereact/toast";
import NumberFormat from 'react-number-format';
import {selectMaestros} from "../../../api/liquidacionDeduccion.service";

export const FormConfig = ({fields, update}) => {
    const [permisos] = UsePermissions();
    const toast = useRef(null);

    const initParams = {
        porcenAdmon: 0,
        porcenPrestaciones: 0,
        cuentadeduccion_id: 0,
        cuentacompensa_id: 0,
        deduccionFija_id: 0
    }
    const [field, setField] = useState(initParams);
    const [deduccion, setDeduccion] = useState([]);
    const [compensacion, setCompensacion] = useState([]);

    useEffect(() => {
        selectMaestros().then(r => {
            if (r.estado === 200) {
                const data = r.data;
                setDeduccion(data.fondo);
                setCompensacion(data.compensacion);

            } else {
                toast.current?.show({severity: 'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }
        });
        return () => {
            setDeduccion([])
            setCompensacion([])
        };
    }, []);

    useEffect(() => {

        if (fields.porcen_admon !== undefined || fields.porcenPrestaciones !== undefined
            || fields.compensacion !== undefined ||  fields.deduccion) {
            setField({...field,
                porcenAdmon: fields.porcen_admon,
                porcenPrestaciones: fields.porcen_prestaciones,
                cuentadeduccion_id: fields.deduccion,
                cuentacompensa_id: fields.compensacion,
                deduccionFija_id: fields.deduccion_fija
            });
        }

        return () => {
            setField(initParams);
        };
    }, [fields]);

    const submit = (e) => {
        try {
            e.preventDefault();

            if (field.porcenAdmon === ""
                || field.porcenPrestaciones === "") {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            update(field)
        } catch (e) {
            console.log(e)
        }

    }

    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerForm>
                <form onSubmit={submit}>
                    <h6 className="title-modal">
                        Configuración general
                    </h6>
                    <div className="row">

                        <ContainerGroupForm width="lg:w-4/12">
                            <label
                                className="label-form"
                                htmlFor="adm"
                            >
                                Procentaje de administracion *
                            </label>

                            <NumberFormat
                                id="adm"
                                thousandsGroupStyle="thousand"
                                value={field.porcenAdmon}
                                suffix="%"
                                displayType="input"
                                type="text"
                                decimalSeparator="."
                                className="form-input-small"
                                thousandSeparator={false}
                                allowNegative={false}
                                onValueChange={(e) => setField({...field, porcenAdmon: e.value})}
                            />

                            {error(field.porcenAdmon, 'required')}
                            {error(field.porcenAdmon, 'maxLength', 11)}
                        </ContainerGroupForm>
                        <ContainerGroupForm width="lg:w-4/12">
                            <label
                                className="label-form"
                                htmlFor="pres"
                            >
                                Procentaje de prestaciones
                            </label>
                            <NumberFormat
                                id="pres"
                                thousandsGroupStyle="thousand"
                                value={field.porcenPrestaciones}
                                suffix="%"
                                displayType="input"
                                type="text"
                                decimalSeparator="."
                                className="form-input-small"
                                thousandSeparator={false}
                                allowNegative={false}
                                onValueChange={(e) => setField({...field, porcenPrestaciones: e.value})}
                            />
                            {error(field.porcenPrestaciones, 'required')}
                            {error(field.porcenPrestaciones, 'maxLength', 11)}

                        </ContainerGroupForm>

                        <ContainerGroupForm width="lg:w-4/12">
                            <label
                                className="label-form"
                                htmlFor="fondo"
                            >
                               Deducción fija sobre compensación: *
                            </label>

                            <select
                                className="form-input-small"
                                value={field.cuentadeduccion_id}
                                onChange={(e) => setField({...field, cuentadeduccion_id: e.target.value})}
                                id="tipoDoc">
                                <option value="0">Ninguna</option>
                                {deduccion.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                            </select>

                            {error(field.cuentadeduccion_id, 'required')}
                        </ContainerGroupForm>
                        <ContainerGroupForm width="lg:w-4/12">
                            <label
                                className="label-form"
                                htmlFor="fondo"
                            >
                                Compensación deducción: *
                            </label>

                            <select
                                className="form-input-small"
                                value={field.cuentacompensa_id}
                                onChange={(e) => setField({...field, cuentacompensa_id: e.target.value})}
                                id="tipoDoc">
                                <option value="0">Ninguna</option>
                                {compensacion.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                            </select>

                            {error(field.cuentadeduccion_id, 'required')}
                        </ContainerGroupForm>
                        <ContainerGroupForm width="lg:w-4/12">
                            <label
                                className="label-form"
                                htmlFor="fondo"
                            >
                                Deducción fija : *
                            </label>

                            <select
                                className="form-input-small"
                                value={field.deduccionFija_id}
                                onChange={(e) => setField({...field, deduccionFija_id: e.target.value})}
                                id="tipoDoc">
                                <option value="0">Ninguna</option>
                                {deduccion.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                            </select>

                            {error(field.deduccionFija_id, 'required')}
                        </ContainerGroupForm>
                    </div>
                    <hr className="mt-6 border-b-1 border-blueGray-300"/>
                    <div className="row mt-2">
                        <ContainerGroupForm width="lg:w-3/12">
                            <button
                                className="primary-color-btn btn"
                                type="submit"
                            >
                                Guardar
                            </button>
                        </ContainerGroupForm>
                    </div>
                </form>
            </ContainerForm>
        </>
    );
};

FormConfig.prototype = {
    fields: PropTypes.object,
    update: PropTypes.func
}

FormConfig.defaultProps = {
    fields: {
        porcenAdmon: 0,
        porcenPrestaciones: 0
    }
}
